import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { LaunchScenarioButton } from '../Scenarios/LaunchScenarioButton';
import ActionDrawer from './ActionDrawer';
import ActionsWorkspace from './ActionsWorkspace';
import { useActualIncidentId } from './hooks/commonHooks';
import {
  openInstantiatedIncidentTask,
  useInstantiateIncidentTask,
} from './hooks/incidentActionHooks';
import { INCIDENT } from './ICSConstants';
import type { ActionEntity } from './hooks/useScopedActionForm';
import { useHwcgFlag } from 'utils/featureFlags';

/**
 * Incident-scoped Actions for Corporate View (IR / Planning). Shares the same
 * ics_incident_actions data as the report Tasks section.
 */
const IncidentActionsPage: React.FC = () => {
  const [showAddDrawer, setShowAddDrawer] = useState(false);
  const [selectedAction, setSelectedAction] = useState<ActionEntity | null>(
    null
  );
  const incidentId = useActualIncidentId();
  const hwcg = useHwcgFlag();
  const { instantiate, isPending: creatingTask } = useInstantiateIncidentTask();

  const addTask = () => {
    if (!hwcg) {
      setShowAddDrawer(true);
      return;
    }
    if (creatingTask) return;
    void openInstantiatedIncidentTask({
      instantiate,
      status: 'Planned',
      onOpen: setSelectedAction,
    });
  };

  return (
    <div className="dark tw:text-foreground">
      <div className="tw:pb-2 tw:text-sm tw:font-medium">Tasks</div>
      <ActionsWorkspace
        scope={INCIDENT}
        storageKey="incident-actions-view"
        onEditAction={setSelectedAction}
        toolbar={
          <div className="tw:flex tw:items-center tw:gap-2">
            <LaunchScenarioButton incidentId={incidentId} />
            <Button size="sm" disabled={creatingTask} onClick={addTask}>
              <Plus className="tw:size-4" />
              Add Task
            </Button>
          </div>
        }
      />

      {!hwcg && showAddDrawer ? (
        <ActionDrawer scope={INCIDENT} toggle={() => setShowAddDrawer(false)} />
      ) : null}
      {selectedAction && (
        <ActionDrawer
          scope={INCIDENT}
          selectedEntity={selectedAction}
          toggle={() => setSelectedAction(null)}
        />
      )}
    </div>
  );
};

export default IncidentActionsPage;
